// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import ResultImageGrid from "root/components/ResultImageGrid";
import dbConsts from "../../data/consts";
import bindActions, { types as ats } from "../../actions";
import { selectContextItems, selectSearchTerm } from "../../selectors";
import FolderList from "../FolderList";

import "./ContextItems.scss";

const DISPLAY_TYPES = {
	LIST: 1,
	GRID: 2,
};

const CONTEXT_DISPLAY_TYPES = {
	[dbConsts.CONTEXTS.FOLDER]: DISPLAY_TYPES.LIST,
	[dbConsts.CONTEXTS.SEARCH]: DISPLAY_TYPES.GRID,
	[dbConsts.CONTEXTS.RECENT]: DISPLAY_TYPES.GRID,
};

type OwnProps = {|
	context: number,
	isMultiple: boolean,
	selectionAction?: Function,
|};

type PropsData = {
	items: Object[],
	selected: string[],
	metadata: Object,
	inProgress: boolean,
	hasMore: boolean;
};

type Props = {
	...OwnProps,
	searchData: { searchTerm: ?string },
	data: PropsData,
	[string]: Function
};

class ContextPhotos extends Component<Props> {

	componentDidMount() {
		this.props[ats.GET_CONTEXT_FILES](this.props.context, {
			term: this.props.searchData.searchTerm,
		});
	}

	onSelection = (id: string, e: MouseEvent) => {
		if (this.props.selectionAction) {
			this.props.selectionAction(id);
		} else {
			this.props[ats.SET_FILE_SELECTION]({
				id,
				e,
				multiple: this.props.isMultiple,
			});
		}
	};

	onFolderClick = (item: { path_lower: string }) => {
		this.props[ats.GET_CONTEXT_FILES](this.props.context, {
			path: item.path_lower,
		});
	};

	onLoadMore = () => {
		this.props[ats.GET_CONTEXT_FILES](this.props.context, {
			extend: true,
			term: this.props.searchData.searchTerm,
		});
	};

	renderItemsByDisplayType(data: PropsData) {
		const displayType = CONTEXT_DISPLAY_TYPES[this.props.context];

		return displayType === DISPLAY_TYPES.LIST
			? <FolderList items={data.items}
			              selected={data.selected}
			              metadata={data.metadata}
			              isMultiple={this.props.isMultiple}
			              selectionAction={this.onSelection}
			              showProgressIndicator={data.inProgress}
			              folderClickAction={this.onFolderClick}/>
			: <ResultImageGrid
				images={data.items}
				selected={data.selected}
				isMultiple={this.props.isMultiple}
				selectionAction={this.onSelection}
				showProgressIndicator={data.inProgress}
				onLoadMore={this.onLoadMore}
				hasMore={data.hasMore}/>;
	}

	render() {
		return <div className={`context-items photos-${this.props.context}`}>
			{this.renderItemsByDisplayType(this.props.data)}
		</div>;
	}
}

export default connect<Props, OwnProps, _, _, _, _>(
	createStructuredSelector({
		data: selectContextItems,
		searchData: selectSearchTerm,
	}),
	bindActions,
)(ContextPhotos);
